export default __webpack_public_path__ + "static/media/Group-1.1088d0f4.png";